import '../scss/Appsview.scss';

import Listview from './Listview';
import UpdateListview from './UpdateListview';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import AppStore from './app-store';
import UserInterfaceHelper from './helper/user-interface-helper';
import { utils } from 'utils';
import { MessageSender } from 'web-message-helper';
import { FirstViewDidMountCommand } from 'kaistore-post-messenger/src/commands';

const CARRIER_CAT_START_AFTER = 100000;

class Appsview extends Component {
  state = {
    categories: [],
    currentTabIndex: 0,
    apps: AppStore.allRemoteItems
  };

  constructor() {
    super();
    window.addEventListener('appstore:change', this.handleStoreChange);
  }

  componentWillMount() {
    const { apps } = this.state;
    this.setState({
      categories: this.getCategories(apps, AppStore.categories)
    });
  }

  componentWillUnmount() {
    window.removeEventListener('appstore:change', this.handleStoreChange);
    UserInterfaceHelper.lastAppsviewIndex.tabOrder = this.state.currentTabIndex;
  }

  handleStoreChange = () => {
    this.setState({
      apps: AppStore.allRemoteItems,
      categories: this.getCategories(
        AppStore.allRemoteItems,
        AppStore.categories
      )
    });
  };

  getCategories(apps, categories) {
    let categoriesCode = [];

    let categoriesForTabs = [];
    let showRecommendedTab = false;
    let carrierCategories = [];

    categoriesCode = apps.map(item => {
      if (!showRecommendedTab && item.remoteInfo.recommended_index > 0) {
        showRecommendedTab = true;
      }
      return item.remoteInfo.category;
    });
    categoriesCode = [...new Set(categoriesCode)];

    // For fixing app-list without any category.
    if (categoriesCode.length === 0) {
      categoriesCode.push('all');
    }

    if (categories.length !== 0) {
      categories.forEach(cat => {
        if (categoriesCode.indexOf(cat.code) !== -1) {
          if (parseInt(cat.code) > CARRIER_CAT_START_AFTER) {
            carrierCategories.push(cat);
          } else {
            categoriesForTabs.push(cat);
          }
        }
      });
      this.localizedCat(carrierCategories);
      this.localizedCat(categoriesForTabs);
    } else {
      // For backward compatible.
      let _ = navigator.mozL10n;
      categoriesCode.forEach(code => {
        let l10nId = 'CAT-' + code;
        let catInfo = {
          code: code,
          displayName: _.get(l10nId)
        };
        if (parseInt(code) > CARRIER_CAT_START_AFTER) {
          carrierCategories.push(catInfo);
        } else {
          categoriesForTabs.push(catInfo);
        }
      });
      this.localizedCat(carrierCategories);
    }

    // append the recommended tab at the position after carrier tab
    if (showRecommendedTab) {
      let _ = navigator.mozL10n;
      let tabCode = 'recommended';
      let l10nId = 'CAT-' + tabCode;

      categoriesForTabs.unshift({
        code: tabCode,
        displayName: _.get(l10nId)
      });
    }

    if (carrierCategories.length > 0) {
      categoriesForTabs = carrierCategories.concat(categoriesForTabs);
    }

    if (AppStore.hasUpdatableApps) {
      categoriesForTabs.unshift({ isUpdateTab: true });
    }

    return categoriesForTabs;
  }

  localizedCat(categories) {
    if (categories.length === 0) {
      return;
    }
    let lang = navigator.mozL10n.language.code || '';
    categories.forEach(cat => {
      let defaultName = cat.name;
      if (cat.locales.hasOwnProperty(lang)) {
        cat['displayName'] = cat.locales[lang];
      } else {
        cat['displayName'] = cat.name;
      }
    });
  }

  handleKeydown(e) {
    switch (e.key) {
      case 'ArrowRight':
        this._nav(1, e);
        break;
      case 'ArrowLeft':
        this._nav(-1, e);
        break;
      case 'ArrowDown':
      case 'ArrowUp':
        this._blur();
        break;
      case 'Backspace':
      case 'Enter':
      case 'SoftRight':
        // pass to parent.
        break;
      case 'BrowserBack':
      case 'Accept':
      default:
        // do nothing.
        e.stopPropagation();
        break;
    }
  }

  handleFocus(e) {
    this._focus();
  }

  _nav(move, e) {
    this._resetActive();
    var currentIndex = this.state.currentTabIndex;
    var length = this.element.querySelectorAll('.tab').length;
    if ('rtl' === document.dir) {
      move = move * -1;
    }
    currentIndex += move;
    if (currentIndex < -0) {
      currentIndex = length - 1;
    } else {
      currentIndex %= length;
    }
    this.setState({ currentTabIndex: currentIndex });
    e.preventDefault();
  }

  _focus() {
    var currentIndex = this.state.currentTabIndex;
    this.activeList = this.element.querySelectorAll('.Listview')[currentIndex];
    this.activeList.focus();
  }

  _blur() {
    this.element.blur();
  }

  _activeTab() {
    var offset;
    var currentIndex = this.state.currentTabIndex;
    this.activeList = this.element.querySelectorAll('.Listview')[currentIndex];
    this.activeList.classList.add('active');

    var tabs = this.element.querySelectorAll('.tab');
    var lastIndex = tabs.length - 1;

    // get activeTab
    this.activeTab = tabs[currentIndex];

    // fetch UL
    var box = this.activeTab.parentElement;
    var tabsWrapperWidth = box.offsetWidth;
    var tabsWrapperLeft = box.offsetLeft;

    var currTabLeft = this.activeTab.offsetLeft;
    var currTabWidth = this.activeTab.offsetWidth;
    var currTabRight = 0;

    // last tabs
    var lastTabLeft = tabs[lastIndex].offsetLeft;
    var lastTabWidth = tabs[lastIndex].offsetWidth;
    var lastTabRight = 0;

    if ('rtl' === document.dir) {
      // RTL (Right to Left)
      // In RTL, offsetLeft will not be reverted to offsetRight.
      // So first offsetLeft of tab will starts from
      // (WrapperWidth -currTabWidth), eg. Each tab's width is 40px.
      // its offsetLeft will be 160px, and 2nd tab will be 120, so on..
      // But in LTR (Left to right), first offsetLeft will start from 0px.

      if (currentIndex === 0) {
        // First tab, translateX offset is 0.
        offset = 0;
      } else {
        if (currTabLeft < 0) {
          offset = tabsWrapperWidth / 2 - (currTabLeft + currTabWidth / 2);
        } else {
          offset = 0;
        }
      }
    } else {
      // LTR (Left to Right)
      currTabRight = tabsWrapperWidth - (currTabLeft + currTabWidth);
      lastTabRight = tabsWrapperWidth - (lastTabLeft + lastTabWidth);
      if (currentIndex === 0) {
        // First tab, translateX offset is 0.
        offset = 0;
      } else if (currentIndex === lastIndex) {
        // Last tab, translateX offset is lastTabRight or 0.
        if (lastTabRight > 0) {
          offset = 0;
        } else {
          offset = (currTabLeft + currTabRight) / 2 - currTabLeft;
        }
      } else {
        // Tab in the middle of somewhere

        // Calcuate the average of current tab's offsetLeft and offsetRight
        // as targetOffset and set translateX to put tab at the center.
        var targetTabLeft = (currTabLeft + currTabRight) / 2;
        var targetOffset = targetTabLeft - currTabLeft;
        if (targetOffset > 0 || lastTabRight > 0) {
          // Offset greater than 0, possibily at the first one or two tabs,
          // or last tab is fully visible, so there's no need move.
          offset = 0;
        } else if (targetOffset < 0 && targetOffset > lastTabRight) {
          // Normal case, simply set offset to targetOffset.
          offset = targetOffset;
        } else if (targetOffset < 0 && targetOffset < lastTabRight) {
          // Offset less than lastTabRight,
          // possibily at the last one or two tabs
          // and can't move more than lastTabRight.
          offset = lastTabRight;
        }
      }
    }
    // apply css.
    box.style.transform = 'translateX(' + offset + 'px)';
    this.activeTab.classList.add('selected');
  }

  _resetActive() {
    var currentIndex = this.state.currentTabIndex;
    this.activeList = this.element.querySelectorAll('.Listview')[currentIndex];
    this.activeList.classList.remove('active');

    this.activeTab = this.element.querySelectorAll('.tab')[currentIndex];
    this.activeTab.classList.remove('selected');
  }

  componentDidMount() {
    this.element.addEventListener('keydown', this.handleKeydown.bind(this));
    this.element.addEventListener('focus', this.handleFocus.bind(this));

    const lastTabOrder = UserInterfaceHelper.lastAppsviewIndex.tabOrder;
    if (lastTabOrder) {
      this.setState({
        currentTabIndex: lastTabOrder
      });
    } else {
      this._activeTab();
    }

    if (UserInterfaceHelper.appsviewMounted) {
      return;
    }

    UserInterfaceHelper.appsviewMounted = true;
    performance.mark('REMOTE_PAGE_RENDERING_END');
    // Inform client store that first view is rendered completely.
    const timestamp = new Date().getTime();
    const command = new FirstViewDidMountCommand({
      detail: {
        timestamp: timestamp
      }
    });
    MessageSender.send(command);
    console.warn('appsview first ready at', timestamp);
    utils.performanceLogs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.currentTabIndex !== this.state.currentTabIndex ||
      prevState.categories.length !== this.state.categories.length
    ) {
      this._activeTab();
      this._focus();
    }
  }

  render() {
    const { apps } = this.state;
    let tabs = this.state.categories;

    return (
      <div
        className="Appsview"
        tabIndex="1"
        ref={target => {
          this.element = target;
        }}
      >
        <gaia-tabs class="h3" underline="child" position="top">
          {tabs.map(
            (result, index) =>
              result.isUpdateTab ? (
                <a tabIndex="1" className="tab">
                  <span data-l10n-id="update" />
                </a>
              ) : (
                <a key={index} tabIndex="1" className="tab">
                  <span data-index={index} data-cat-id={result.code}>
                    {result.displayName}
                  </span>
                </a>
              )
          )}
        </gaia-tabs>

        <div className="ListviewBox">
          {tabs.map(
            (result, index) =>
              result.isUpdateTab ? (
                <UpdateListview
                  isCurrentList={index === this.state.currentTabIndex}
                />
              ) : (
                <Listview
                  apps={apps}
                  key={index}
                  category={result.code}
                  order={index}
                  isCurrentList={index === this.state.currentTabIndex}
                />
              )
          )}
        </div>
      </div>
    );
  }
}

export default Appsview;



/** WEBPACK FOOTER **
 ** ./src/Appsview.js
 **/